// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";
import { parseAPIFilters } from "./utils"

// Constants
import * as ACTIONS from "./actionTypes";

// Functions
import { createAPINetworkInstance } from '../../../../../common/api';

// Types
import { ActionGetClientAPI, getFiltersAPIError, getFiltersAPISuccess, } from './actions';
import { FilterItem } from 'features/Dealers/Performance/Filter/state/types';

function* getFilters(action: ActionGetClientAPI) {
    try {
        const { data } = yield call(createAPINetworkInstance().get, "/utils/performance_filters");
        const filtersItems: FilterItem[] = parseAPIFilters(data);
        yield put(getFiltersAPISuccess(filtersItems));
    } catch (err) {
        yield put(getFiltersAPIError(err));
    }
}

export default function* filtersSagas() {
    yield takeLatest(ACTIONS.GET_FILTERS_API_REQUEST, getFilters);
}
